export default window.Phaser;
